<script setup lang="ts">
import { computed } from 'vue'

export interface UiAvatarProps {
  name?: string | null
  round?: boolean
}

const props = withDefaults(defineProps<UiAvatarProps>(), {
  name: null,
  round: false,
})

const cleanName = computed<string>(() => {
  if (props.name?.includes('@')) {
    return props.name.split('@')[0].replaceAll('.', ' ')
  }
  return props.name ?? ''
})

const imageData = computed<string>(() => {
  if (props.name && props.name.length > 0) {
    return `https://icotar.com/initials/${encodeURIComponent(cleanName.value)}.png`
  }
  return 'https://i.imgur.com/L2Py2dG.png'
})

defineOptions({
  inheritAttrs: false,
})
</script>

<template>
  <div class="avatar">
    <div
      v-bind="$attrs"
      :class="{ 'rounded-full': round, 'mask mask-squircle': !round }"
    >
      <img
        class="max-w-[80px] object-cover"
        :src="imageData"
        :title="cleanName ?? undefined"
      />
    </div>
  </div>
</template>
